import $ from 'jquery';
import { fabric } from 'fabric';
import { modifyState } from '~src/state';
import { toggleEditorSidebar, hideSidebarTab } from '~src/sidebarLegacy';
import { getActiveMagicFrameActive } from '~core/magicFrame';
import editorConfig from '~config/editorConfig';
import { EdgeResizer, loadSvgAsync } from '~src/utils';
import { handleMagicFrameFrameColors } from './handleMagicFrameSvgColors';

export const handleMagicFrameFrameSelection = async (
  url,
  width,
  height,
  svgClip
) => {
  hideSidebarTab('immagini');
  toggleEditorSidebar();
  modifyState('sidebarCurrentBackgroundsTag', editorConfig.magicFrameTag);
  modifyState('magicFrameSelectFramePhotoActive', false);
  const tagId = window.editorConfig.sidebarTags.items.find(
    (tag) => tag.name === editorConfig.magicFrameTag
  );
  $('#select-ricerca-immagini').val(tagId.objectId).trigger('change');

  const magicFrame = getActiveMagicFrameActive();
  // Compute current displayed size
  const displayedW = magicFrame.width * magicFrame.scaleX;
  const displayedH = magicFrame.height * magicFrame.scaleY;

  // Target intrinsic frame size (respect aspect of selected frame)
  const frameW = width || magicFrame.width;
  const frameH = height || magicFrame.height;

  // Pick a uniform scale that best preserves the current footprint
  const scaleW = displayedW / frameW;
  const scaleH = displayedH / frameH;
  const errIfUseW = Math.abs(frameH * scaleW - displayedH);
  const errIfUseH = Math.abs(frameW * scaleH - displayedW);
  const uniformScale = errIfUseW <= errIfUseH ? scaleW : scaleH;

  // Apply new intrinsic size and uniform scale
  magicFrame.set({
    width: frameW,
    height: frameH,
    scaleX: uniformScale,
    scaleY: uniformScale,
  });

  // Load the new frame artwork sized to the intrinsic width (it will be scaled uniformly visually)
  const resizedImg = new EdgeResizer(url).scaleToWidth(frameW);
  await magicFrame.updateFrame(resizedImg);

  if (svgClip) {
    const { objects } = await loadSvgAsync(svgClip);
    const firstPath = objects[0];
    magicFrame.clipping = firstPath;
  } else {
    magicFrame.clipping = new fabric.Rect({
      left: 0,
      top: 0,
      width: frameW,
      height: frameH,
      fill: 'transparent',
    });
  }

  // Refresh and re-scale the person layer to fit the new frame width
  magicFrame.updatePerson(magicFrame.getPersonSrc()).then(() => {
    try {
      magicFrame.scalePersonToWidth(magicFrame.width * magicFrame.scaleX);
      magicFrame.scalePersonToWidth(magicFrame.width * magicFrame.scaleX);
    } catch (e) {
      console.error(
        'Failed scaling MagicFrame person after frame selection',
        e
      );
    }
    // Refresh frame color pickers if it's an SVG
    handleMagicFrameFrameColors(magicFrame);

    window.canvas.renderAll();
  });
};
